<div class="sidebar-nav-container" [ngClass]="collapseMenu ? 'close' : 'open'">
  <div class="sidebar-nav-inner-container">
    <div class="logo-wrapper collapse-btn-wrapper">
      <a class="navbar-brand" href="javascript:void(0)">
        <img src="../../../../assets/img/logo.png" class="img-fluid full-logo"
          [ngClass]="collapseMenu ? 'd-none' : 'd-block'" />
        <img src="../../../../assets/img/small_logo.png" class="img-fluid half-logo"
          [ngClass]="collapseMenu ? 'd-block' : 'd-none'" />
      </a>
      <button class="btn collapse-btn" [ngClass]="collapseMenu ? 'close' : 'open'" (click)="sidenavCollapseMenu()">
        <img src="../../../../assets/img/icons/menu_open.svg" />
      </button>
    </div>
    <div class="accordion" id="sidebar-navigation">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button (click)="collapseMenu ? sidenavCollapseMenu() : ''" class="accordion-button collapsed"
            [ngClass]="collapseMenu ? 'close' : 'open'" type="button" data-bs-toggle="collapse"
            data-bs-target="#request" aria-expanded="true" aria-controls="request">
            <img src="../../../assets/img/icons/sidebar_request.svg" class="img-fluid accordion-btn-icon" />
            <span class="accordion-btn-text">{{globalConstants.REQUEST_SIDEBAR}}</span>
          </button>
        </h2>
        <div id="request" class="accordion-collapse collapse show" [ngClass]="collapseMenu ? 'close' : 'open'"
          data-bs-parent="#sidebar-navigation">
          <div class="side-nav-menu-wrapper">
            <ul class="side-nav-menu-list">
              <li class="side-nav-menu-list-item" *ngIf="!nonEmployeeFlag">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu()" class="side-nav-menu-list-item-link"
                  routerLinkActive="active" routerLink="pending-approval">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.PENDING_APPROVALS_SIDEBAR}}</span>
                  </div>
                  <span class="menu-item-count">{{(countData?.pendingApprovalCount) ? countData?.pendingApprovalCount :
                    ''
                    }}</span>
                </a>
              </li>
              <li class="side-nav-menu-list-item" *ngIf="!nonEmployeeFlag">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu()" class="side-nav-menu-list-item-link"
                  routerLinkActive="active" routerLink="drafts">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.DRAFTS_SIDEBAR}}</span>
                  </div>
                  <span class="menu-item-count">{{(countData?.draftCount) ? countData?.draftCount : '' }}</span>
                </a>
              </li>
              <li class="side-nav-menu-list-item" *ngIf="!nonEmployeeFlag">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu()" class="side-nav-menu-list-item-link"
                  routerLinkActive="active" routerLink="processed-request">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.PROCESSED_SIDEBAR}}</span>
                  </div>
                  <span class="menu-item-count">{{(countData?.processedCount) ? countData?.processedCount : '' }}</span>
                </a>
              </li>
              <li class="side-nav-menu-list-item" *ngIf="!nonEmployeeFlag">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu()" class="side-nav-menu-list-item-link"
                  routerLinkActive="active" routerLink="returned-request">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.RETURNED_SIDEBAR}}</span>
                  </div>
                  <span class="menu-item-count">{{(countData?.returnedCount) ? countData?.returnedCount : '' }}</span>
                </a>
              </li>
              <li class="side-nav-menu-list-item">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu()" class="side-nav-menu-list-item-link"
                  routerLinkActive="active" routerLink="submitted-request">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.SUBMITTED_SIDEBAR}}</span>
                  </div>
                  <span class="menu-item-count">{{(countData?.submittedCount) ? countData?.submittedCount : '' }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="accordion-item" *ngIf="!nonEmployeeFlag && (countData?.myStaffCount || countData?.myDepartmentCount)">
        <h2 class="accordion-header">
          <button (click)="collapseMenu ? sidenavCollapseMenu() : ''" class="accordion-button collapsed"
            [ngClass]="collapseMenu ? 'close' : 'open'" type="button" data-bs-toggle="collapse"
            data-bs-target="#staffing" aria-expanded="false" aria-controls="staffing">
            <img src="../../../../assets/img/icons/sidebar_staffing.svg" class="img-fluid accordion-btn-icon" />
            <span class="accordion-btn-text">{{globalConstants.STAFFING_SIDEBAR}}</span>
          </button>
        </h2>
        <div id="staffing" class="accordion-collapse collapse" [ngClass]="collapseMenu ? 'close' : 'open'"
          data-bs-parent="#sidebar-navigation">
          <div class="side-nav-menu-wrapper">
            <ul class="side-nav-menu-list">
              <li class="side-nav-menu-list-item" *ngIf="countData?.myStaffCount">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu()" class="side-nav-menu-list-item-link"
                  routerLinkActive="active" routerLink="staffing/my-staff">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.MY_STAFF_SIDEBAR}}</span>
                  </div>
                  <span class="menu-item-count">{{(countData?.myStaffCount) ? countData?.myStaffCount : '' }}</span>
                </a>
              </li>
              <li class="side-nav-menu-list-item" *ngIf="countData?.myDepartmentCount">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu()" class="side-nav-menu-list-item-link"
                  routerLinkActive="active" routerLink="staffing/my-department">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.MY_DEPARTMENT_SIDEBAR}}</span>
                  </div>
                  <span class="menu-item-count">{{(countData?.myDepartmentCount) ? countData?.myDepartmentCount : ''
                    }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="accordion-item"
        *ngIf="!nonEmployeeFlag &&(userRole.includes('BusinessPartner') || userRole.includes('SystemAdmin') || userRole.includes('ITAdmin'))">
        <h2 class="accordion-header">
          <button (click)="collapseMenu ? sidenavCollapseMenu() : ''" class="accordion-button collapsed"
            [ngClass]="collapseMenu ? 'close' : 'open'" type="button" data-bs-toggle="collapse" data-bs-target="#people"
            aria-expanded="false" aria-controls="people">
            <img src="../../../../assets/img/icons/sidebar_people.svg" class="img-fluid accordion-btn-icon" />
            <span class="accordion-btn-text">{{globalConstants.PEOPLE_SIDEBAR_NAV}}</span>
          </button>
        </h2>
        <div id="people" class="accordion-collapse collapse" [ngClass]="collapseMenu ? 'close' : 'open'"
          data-bs-parent="#sidebar-navigation">
          <div class="side-nav-menu-wrapper">
            <ul class="side-nav-menu-list">
              <li class="side-nav-menu-list-item">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu()" class="side-nav-menu-list-item-link"
                  routerLinkActive="active" routerLink="people/all-Employees">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.ALL_EMPLOYEE_SIDEBAR_NAV}}</span>
                  </div>
                  <span class="menu-item-count">{{(countData?.employeesCount) ? countData?.employeesCount : '' }}</span>
                </a>
              </li>
              <li class="side-nav-menu-list-item">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu()" class="side-nav-menu-list-item-link"
                  routerLinkActive="active" routerLink="people/non-Employees">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.NON_EMPLOYEE_SIDEBAR_NAV}}</span>
                  </div>
                  <span class="menu-item-count">{{(countData?.nonEmployeesCount) ? countData?.nonEmployeesCount : ''
                    }}</span>
                </a>
              </li>
              <li class="side-nav-menu-list-item">
                <a href="javascript:void(0)" (click)="smallDeviceCollapseMenu();openOnBoardModal()"
                  class="side-nav-menu-list-item-link" routerLinkActive="active">
                  <div class="side-nav-menu-link-icon-wrap">
                    <img src="../../../../assets/img/icons/baselinef_fullscreen_exit_grey.svg"
                      class="menu-item-icon menu-item-icon-grey" />
                    <img src="../../../../assets/img/icons/baseline_fullscreen_exit_orange.svg"
                      class="menu-item-icon menu-item-icon-orange" />
                    <span class="menu-list-item-link-text">{{globalConstants.ON_BOARDING_SIDEBAR_NAV}}</span>
                  </div>
                  <!-- <span class="menu-item-count">{{(countData?.nonEmployeesCount) ? countData?.nonEmployeesCount : ''
                    }}</span> -->
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <span class="buildNumber" [ngClass]="collapseMenu ? 'close' : 'open'">v1.{{buildNumber}}</span>
</div>